import { render, staticRenderFns } from "./register-addr.vue?vue&type=template&id=18c19262&scoped=true&"
import script from "./register-addr.vue?vue&type=script&lang=js&"
export * from "./register-addr.vue?vue&type=script&lang=js&"
import style0 from "./register-addr.vue?vue&type=style&index=0&id=18c19262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c19262",
  null
  
)

export default component.exports